import { useEffect } from 'react';

type Props = {
  target?: HTMLElement | null;
  className: string;
};
const useClassName = ({ target, className }: Props) => {
  useEffect(() => {
    if (!target || !className) {
      return;
    }

    target.classList.add(className);

    return () => {
      target.classList.remove(className);
    };
  }, [className, target]);
};
export default useClassName;
